import CollectionFilter from 'utils/lib/shopify-collection-filter';
import { component } from 'picoapp';
import { renderProductItem, Product as ProductType } from 'utils/js-templates';

export default component(async (node, ctx) => {
  const siteNavigation = document.querySelector('#shopify-section-header');
  const sortTrigger = node.querySelector('[data-sort-trigger]');
  const sortButtons:NodeListOf<HTMLButtonElement> = node.querySelectorAll('[data-sort-button]');
  const sortMenu:HTMLElement = node.querySelector('[data-sort-menu]');
  const sortActiveLabel = node.querySelector('[data-sort-active]');
  const sortSelectElement:HTMLSelectElement = node.querySelector('[data-sort-select]');
  const totalActiveFiltersIndicator:HTMLSpanElement = document.querySelector('[data-total-active]');
  const resetFilterButtons:NodeListOf<HTMLButtonElement> = document.querySelectorAll('[data-reset-filter]');
  let initialPageLoad = true;
  const themeTranslations = window.theme.strings.collection;
  const sortVals = [
    { val: 'best-selling', title: themeTranslations.sort.bestSelling ?? 'Bestsellers' },
    { val: 'price-ascending', title: themeTranslations.sort.priceAscending ?? 'Price, low-high' },
    { val: 'price-descending', title: themeTranslations.sort.priceDescending ?? 'Price, high-low' },
    { val: 'created-ascending', title: themeTranslations.sort.createdAscending ?? 'Created, new' },
    { val: 'created-descending', title: themeTranslations.sort.createdDescending ?? 'Created, old' },
  ];

  sortTrigger.addEventListener('click', () => {
    sortMenu.hidden = !sortMenu.hidden;
    sortTrigger.setAttribute('data-sort-trigger', `${!sortMenu.hidden}`);
  });

  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement;

    if (!sortTrigger.contains(target)) {
      sortMenu.hidden = true;
      sortTrigger.setAttribute('data-sort-trigger', 'false');
    }
  });

  sortButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const sortOption = button.dataset.sortButton;
      sortSelectElement.value = sortOption;
      sortSelectElement.dispatchEvent(new Event('change'));
      const matchingVal = sortVals.find((sortVal) => sortVal.val === sortOption);
      sortActiveLabel.textContent = matchingVal.title;
    });
  });

  const paginationLoadMoreButton:HTMLElement = node.querySelector('[data-load-more]');
  const productOutputContainer = node.querySelector('[data-product-output]');

  const productSortings = [...node.querySelectorAll('[data-sort-select]')];

  const renderProduct = ({ product }) => {
    const productItem:ProductType = {
      id: product.id,
      available: product.available,
      compareAtPrice: product.compareAtPrice,
      price: product.price,
      tags: product.tags,
      title: product.title,
      type: product.product_type,
      url: product.url,
      variantID: product.variantID,
      vendor: product.vendor,
      labels: product.labels,
      clerk: false,
    };

    if (product.images.length > 0) {
      productItem.image = {
        alt: product.images[0].alt,
        src: product.images[0].src,
        width: product.images[0].width,
        height: product.images[0].height,
      };
    }

    return renderProductItem(productItem);
  };

  const renderSort = (val) => `<option value="${val.val}">${val.title}</option>`;
  const removeFunc = (groupEl) => groupEl.remove();

  const renderFilter = (val, className) => `
      <li class="collection__filter--input ${className}" data-value="${val?.val ?? val}">
        <span class="collection__filter--checkbox">
          ${window.theme.icons.checkmark}
        </span>
        <p>${val?.title ?? val}</p>
      </li>
    `;

  const removeBrandFromModel = (model) => model.split('_').pop();

  const renderModelFilter = (val, className) => `
    <li class="collection__filter--input ${className}" data-value="${val?.val ?? val}">
      <span class="collection__filter--checkbox">
        ${window.theme.icons.checkmark}
      </span>
      <p>${removeBrandFromModel(val?.title ?? val)}</p>
    </li>
  `;

  const removeFilter = (groupEl) => {
    const item = groupEl.closest('[data-filter-item]');
    item.remove();
  };

  const {
    handle,
    productCount,
    defaultSort,
    pageSize,
  } = JSON.parse(node.dataset.config);

  const collectionFilter = CollectionFilter({
    collection: {
      handle,
      productCount,
    },
    defaultSort,
    pagination: {
      type: 'button',
      element: paginationLoadMoreButton,
      pageSize,
    },
    render: {
      func: renderProduct,
      output: productOutputContainer,
    },
    reset: {
      element: [...document.querySelectorAll('[data-reset-filter]')],
    },
    prerender: true,
    filters: [
      {
        type: 'sort',
        name: 'sort_by',
        groupEl: productSortings,
        vals: sortVals,
        renderFunc: renderSort,
        removeFunc,
      },
      {
        type: 'vendor',
        name: 'vendor',
        groupEl: [...document.querySelectorAll('[data-filter-type="vendor"]')],
        renderFunc: [renderFilter, renderFilter],
        removeFunc: [removeFilter, removeFilter],
      },
      {
        type: 'tagPrefix',
        prefix: 'PIM_Brand_',
        name: 'brand',
        groupEl: [...document.querySelectorAll('[data-filter-type="brand"]')],
        renderFunc: [renderFilter, renderFilter],
        removeFunc: [removeFilter, removeFilter],
      },
      {
        type: 'tagPrefix',
        prefix: 'PIM_Device_',
        name: 'device',
        groupEl: [...document.querySelectorAll('[data-filter-type="device"]')],
        renderFunc: [renderFilter, renderFilter],
        removeFunc: [removeFilter, removeFilter],
      },
      {
        type: 'tagPrefix',
        prefix: 'PIM_FitToModel_',
        name: 'model',
        groupEl: [...document.querySelectorAll('[data-filter-type="model"]')],
        renderFunc: [renderModelFilter, renderModelFilter],
        removeFunc: [removeFilter, removeFilter],
      },
      {
        type: 'tagPrefix',
        prefix: 'type_',
        name: 'type',
        groupEl: [...document.querySelectorAll('[data-filter-type="type"]')],
        renderFunc: [renderFilter, renderFilter],
        removeFunc: [removeFilter, removeFilter],
      },
      {
        type: 'type',
        name: 'function',
        groupEl: [...document.querySelectorAll('[data-filter-type="function"]')],
        renderFunc: [renderFilter, renderFilter],
        removeFunc: [removeFilter, removeFilter],
      },
    ],
  });

  const paginationElement:HTMLElement = node.querySelector('[data-pagination]');
  const paginationCurrentCount = node.querySelector('[data-pagination-count]');
  const paginationTotalCount = node.querySelector('[data-pagination-total]');
  const paginationProgressBar:HTMLElement = node.querySelector('[data-pagination-progress]');

  const updatePagination = (pagination, filtered) => {
    const progress = (pagination.viewed / filtered) * 100;

    paginationCurrentCount.textContent = pagination.viewed;
    paginationTotalCount.textContent = filtered;
    paginationProgressBar.style.width = `${progress}%`;

    paginationLoadMoreButton.hidden = filtered <= pagination.viewed;
    paginationElement.hidden = !filtered;
  };

  collectionFilter.on('filterProducts', (e) => {
    if (e.queries.length > 0 && !initialPageLoad) {
      const headerOffset = siteNavigation.clientHeight;
      const elementPosition = productOutputContainer.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset - 16;

      if (window.scrollY > offsetPosition) {
        window.scrollTo({
          top: offsetPosition,
        });
      }
    }

    resetFilterButtons.forEach((button) => {
      button.hidden = !e.queries.length;
    });

    document.dispatchEvent(new CustomEvent('collection:filter:render', { detail: e.queries }));
    initialPageLoad = false;

    const totalQueries = e.queries.flatMap((x) => x.vals);
    totalActiveFiltersIndicator.innerText = totalQueries.length;
    totalActiveFiltersIndicator.hidden = !totalQueries.length;
  });

  collectionFilter.on('renderProducts', ({ pagination, ...rest }) => {
    ctx.emit('app:remount');
    const filtered = rest.products.filtered.length;
    updatePagination(pagination, filtered);

    if (rest.queries.find((x) => x.name === 'sort_by')) {
      sortButtons.forEach((button) => {
        if (button.dataset.sortButton === sortSelectElement.value) {
          button.setAttribute('data-active', 'true');
        } else {
          button.setAttribute('data-active', 'false');
        }
      });
    }
  });
});
